import { getLocalDateString } from '@@utils/getLocalDateString';
import {
    ContentText,
    SecondaryTitle,
    SectionTitle,
    VerticalContainer
} from '@american-autonomy/rantizo-ui';

import HorizontalGridContainer from 'components/containers/HorizontalGridContainer';
import SubscriptionSummaryCardContainer from 'components/containers/SubscriptionSummaryCardContainer';

import useTranslation from './hooks/useTranslation';

import { FREE, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const StripeSubscriptionCard: FunctionComponent<Props> = ({
    stripeSubscription,
    testId = TEST_ID
}) => {
    const { NOT_SET, RENEWALDATE, SEATS, SUBSCRIPTION, SUMMARY, TOTAL_SEATS } = useTranslation();

    const isFreeOnly = stripeSubscription?.every(({ subscription }) => subscription === FREE);

    const tableHeaders = [SUBSCRIPTION];

    if (!isFreeOnly) {
        tableHeaders.push(RENEWALDATE, SEATS);
    }
    const totalSeats = stripeSubscription?.reduce((total, { numSeats }) => total + numSeats, 0);

    return (
        <SubscriptionSummaryCardContainer className={styles.container} testId={testId}>
            <SectionTitle text={SUMMARY} />

            <SecondaryTitle text={TOTAL_SEATS(totalSeats)} />

            <VerticalContainer className={styles.wrapper}>
                <HorizontalGridContainer className={styles.horizontalGridContainer}>
                    {tableHeaders.map(header => (
                        <SecondaryTitle key={header} text={header} />
                    ))}
                </HorizontalGridContainer>

                {stripeSubscription?.map(({ expirationDate, id, numSeats, subscription }) => (
                    <HorizontalGridContainer className={styles.horizontalGridContainer} key={id}>
                        <ContentText text={subscription} />

                        {!isFreeOnly && (
                            <>
                                <ContentText
                                    text={
                                        expirationDate
                                            ? getLocalDateString(expirationDate)
                                            : NOT_SET
                                    }
                                />

                                <ContentText text={String(numSeats)} />
                            </>
                        )}
                    </HorizontalGridContainer>
                ))}
            </VerticalContainer>
        </SubscriptionSummaryCardContainer>
    );
};

export default StripeSubscriptionCard;
